module.exports = __webpack_public_path__ + "static/media/100-winners.132520bc.png";